export default __webpack_public_path__ + "d0a48dbe9e682245ce9b7647d00589a5.webp";